// custom-mini-cart-variant.js
(function () {
  // Debounce para no disparar demasiadas lecturas a /cart.js
  let t;
  function debounce(fn, wait) {
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function renderMiniCartVariant() {
    // Si no hay mini-carrito en el DOM, no hacemos nada
    var widget = document.querySelector('.widget_shopping_cart_content');
    if (!widget) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;

        cart.items.forEach(function (it) {
          // En /cart.js, items[i].id es el variant_id
          var removeBtn = widget.querySelector('.shopify-mini-cart-item [data-product_id="' + it.id + '"]');
          if (!removeBtn) return;

          var li = removeBtn.closest('.shopify-mini-cart-item');
          if (!li) return;

          // Contenedor donde pondremos la talla
          var info = li.querySelector('.cart-info');
          if (!info) return;

          // Evitar duplicados: si ya lo pintamos en este ciclo, no repetimos
          var meta = li.querySelector('.cart__meta-text');
          if (!meta) {
            meta = document.createElement('div');
            meta.className = 'cart__meta-text';
            meta.style.marginTop = '4px';
            meta.style.fontSize = '.85rem';
            info.insertBefore(meta, info.querySelector('.quantity')); // antes de la línea de cantidad
          }

          // Si el tema ya imprime opciones vía Liquid, no sobreescribimos
          if (meta.dataset.enhanced === '1') return;

          var label = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';

          // Si tu producto solo tiene 1 opción (Talla), variant_title == "M", "S", etc.
          // Si tiene más (ej: "Negro / M"), puedes mostrarlo tal cual o partirlo.
          // Ejemplo: quedarnos con el último valor como talla:
          if (label && label.indexOf(' / ') > -1) {
            var parts = label.split(' / ');
            label = parts[parts.length - 1]; // último valor (usualmente talla)
          }

          meta.innerHTML = label
            ? '<div class="cart-item-variant"><span class="label">Talla:</span> <span class="value">' + label + '</span></div>'
            : '';

          meta.dataset.enhanced = '1';
        });
      })
      .catch(function () { /* silencio */ });
  }

  var safeRender = debounce(renderMiniCartVariant, 120);

  document.addEventListener('DOMContentLoaded', function () {
    // 1) Primera carga
    safeRender();

    // 2) Observa cambios del mini-carrito (cuando Woodmart lo actualiza por AJAX)
    var widget = document.querySelector('.widget_shopping_cart_content');
    if (widget && 'MutationObserver' in window) {
      var mo = new MutationObserver(safeRender);
      mo.observe(widget, { childList: true, subtree: true });
    }

    // 3) Hooks genéricos de muchos temas/eventos
    // (si Woodmart dispara alguno, capturamos)
    ['added_to_cart', 'cart:updated', 'ajaxCart.afterCartLoad'].forEach(function (ev) {
      document.body.addEventListener(ev, safeRender, true);
    });
  });
})();
